import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import About from "@/pages/About";
import ServicesList from "@/pages/ServicesList";
import ProductsList from "@/pages/ProductsList";
import BlogList from "@/pages/BlogList";
import Contact from "@/pages/Contact";
import Detail from "@/pages/Detail";
import NotFound from "@/pages/NotFound";
import QuickAppointmentPage from "@/pages/QuickAppointmentPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/hakkimizda" element={<About />} />
            <Route path="/hizmetlerimiz" element={<ServicesList />} />
            <Route path="/urunlerimiz" element={<ProductsList />} />
            <Route path="/ayak-sagligi-urunleri" element={<ProductsList />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/iletisim" element={<Contact />} />
            <Route path="/hizli-randevu" element={<QuickAppointmentPage />} />
            <Route path="/404" element={<NotFound />} />
            <Route path="/:slug" element={<Detail />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppFloat />
      </BrowserRouter>
    </div>
  );
}

export default App;
